import React from "react";
import { Select, Divider, Box } from '@mantine/core';

import InputWrapperCustom from "../general/InputWrapperCustom";
import BarangFormCekDetilQC from "./BarangFormCekDetilQC";

const BarangFormCekQC = ({ stateData, fnOnChangeMaster, fnOnChangeDetil }) => {

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={stateData.data.label}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
            >
                <Select
                    disabled
                    readOnly
                    defaultValue={stateData.data.value.masterId}
                    data={[
                        { value: '', label: 'Pilih Form Cek' },
                        ...stateData.dataBarangFormCek.map(key => ({ value: key.barang_form_cek_id, label: key.barang_form_cek_name }))
                    ]}

                    styles={(tema) => ({
                        input: {
                            backgroundColor: `${tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]} !important`,
                            opacity: `1 !important`
                        }
                    })}
                />
            </InputWrapperCustom>

            <Box
                mt={(Array.isArray(stateData.data.value.detil) && stateData.data.value.detil.length > 0) ? 'xl' : 0}
            >
                {(Array.isArray(stateData.data.value.detil) && stateData.data.value.detil.length > 0) && Object.keys(stateData.data.value.detil).map((key, index) => {
                    return (
                        <Box
                            key={key}
                            mt='md'
                        >
                            <BarangFormCekDetilQC
                                stateData={stateData.data.value.detil[key]}
                                stateDataProject={{
                                    projectId: stateData.projectId,
                                    projectProcess: stateData.projectProcess,
                                    projectIsCancel: stateData.projectIsCancel,
                                    projectFormCekMasterId: stateData.data.value.masterId,
                                    userAccess: stateData.userAccess
                                }}
                                fnOnChange={(ValueArray) => fnOnChangeDetil(ValueArray)}
                            />

                            {(Number(index) + 1) !== stateData.data.value.detil.length && <Divider mt='md' />}
                        </Box>
                    )
                })}
            </Box>
        </React.Fragment>
    )
}

export default BarangFormCekQC;